import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
// import goalService from './goalService'
import { createService, getAllService, getOneService } from "./services";

// //get user from localStorage
// const user = JSON.parse(localStorage.getItem('goal'))

const initialState = {
    orders: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''

}

//create goal
export const createOrder = createAsyncThunk('orders/create', async (orderData:any, thunkAPI:any) => {
    try {
        const res = await createService(orderData);
        if (res?.status === 201) {

            return res?.data;

            
        }
        // const token = thunkAPI.getState().auth.user.token
        // return res?.data;

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})
//get goas
export const getOrders = createAsyncThunk('orders/getAll', async (query:any,thunkAPI:any) => {
    try {
        const res = await getAllService(query);
        if (res?.status === 200) {

            return res?.data;

            
        }

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})

//get goal
// export const getGoal = createAsyncThunk('goals/getGoal', async (id:any,thunkAPI:any) => {
//     try {
//         const token = thunkAPI.getState().auth.user.token
//         return await goalService.deleteGoal(id,token)

//     } catch (error) {
//         const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
//         return thunkAPI.rejectWithValue(message)

//     }

// })



export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        reset: (state:any) => initialState
    },
    extraReducers: (builder:any) => {
        builder.addCase(createOrder.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(createOrder.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.orders = action.payload

        })
        .addCase(createOrder.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload


        }).addCase(getOrders.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(getOrders.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.orders = action.payload

        })
        .addCase(getOrders.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload


        })
    }
})
export const { reset } =  orderSlice.actions
export default orderSlice.reducer